import React, { useContext, useEffect, useState } from 'react'
import { ContextUserInfo } from '../MainPanel';
import { ContextNotification, severitys } from '../../../App';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import { MdDelete } from 'react-icons/md';
import { Button, IconButton, Tooltip } from '@mui/material';
import hotelApi from '../../../api/hotelApi';
import reservationApi from '../../../api/reservationApi';


const UpdatePlanToLastForm = ({ id, refreshGrid }) => {
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const { open, setOpen } = useContext(ContextNotification);
    const [openUpdatePlanToLast, setOpenUpdatePlanToLast] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    useEffect(() => {

    }, []);
    const handleOpenUpdatePlanToLast = (id) => {
        setOpenUpdatePlanToLast(true);
    };
    const handleUpdatePlanToLast = () => {
        setSubmitLoading(true);
        reservationApi.UpdatePlanToLast([id]).then((res) => {
            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                refreshGrid(true)
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => { setOpenUpdatePlanToLast(false); setSubmitLoading(false) });
    };
    return (
        <div>

            <Button variant='contained' onClick={() => {
                handleOpenUpdatePlanToLast(id)
            }}>
                به روز رسانی
            </Button>

            <ConfirmationDialog
                open={openUpdatePlanToLast}
                handleClose={() => setOpenUpdatePlanToLast(false)}
                func={handleUpdatePlanToLast}
                title={"آیا از به روز رسانی این رزرو اطمینان دارید؟"}
                loading={submitLoading}
            />
        </div>
    )
}

export default UpdatePlanToLastForm